import * as React from 'react';
import '../css/chart.css'
import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  DateTimeValidationError,
  FieldSelectedSections,
} from '@mui/x-date-pickers/models';
import {
    unstable_useNumberInput as useNumberInput,
    UseNumberInputParameters,
  } from '@mui/base/unstable_useNumberInput';
  import { styled } from '@mui/system';
  import { unstable_useForkRef as useForkRef } from '@mui/utils';
import { DateTimePicker } from '@mui/x-date-pickers';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Typography } from '@mui/material';

const CustomNumberInput = React.forwardRef(

  function CustomNumberInput(
    props: UseNumberInputParameters & any & React.InputHTMLAttributes<HTMLInputElement>, 
    ref: React.ForwardedRef<HTMLInputElement>, 
    
  ) {

    let varTid = ''

    const {
      getRootProps,
      getInputProps,
      getIncrementButtonProps,
      getDecrementButtonProps,
      focused,
    } = useNumberInput(props);

  
    const inputProps = getInputProps();
    const [value, setValue] = React.useState<Dayjs | null>(null);
    const [validation, setValidation] = React.useState<DateTimeValidationError>(null);


    // Make sure that both the forwarded ref and the ref returned from the getInputProps are applied on the input element
    inputProps.ref = useForkRef(inputProps.ref, ref);

    const [selectedSections, setSelectedSections] =
    useState<FieldSelectedSections>(null);
    const inputRef = React.useRef<HTMLInputElement>(null);
    let date_test = null

    const handleOnChange  = async  (date: Dayjs | null) => {
            
      if(date == null || date.format('L') == 'Invalid Date'){
      }
      else{  
        setValue(date)
        date_test= date
        props.getDateInput(date)
        // props.setDateInput(date)
        props.setAllowedToFetch(true)
        props.refetch()
        console.log(date)

        }
    
    }
    
    console.log(date_test)

    return (
      
      <StyledInputRoot {...getRootProps()} label="root" className={focused ? 'focused input root' : 'input root'}>

      <div className='hour-button-group'>
        <div className='button-spacer'></div>
        <div className='icon-button-group'>
        <StyledStepperButton {...getDecrementButtonProps()} className="decrement-hour"
        onClick={() => {props.setSelectedSection("hours");}}>
          ◂
        </StyledStepperButton>
        <span className='libre-franklin-chart' style={{paddingLeft:'3px', fontSize:'11px', color:'rgb(2, 51, 101)'}}>HR</span>
        <StyledStepperButton {...getIncrementButtonProps()} className="increment-hour" 
          onClick={() => {
            props.setSelectedSection("hours");
        }}
        >
          ▸
        </StyledStepperButton>
       
        </div>
        </div>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
      
        <DateTimeFieldLg sx={{ minWidth: '100px', width: '100%'}}
          views={['year', 'month', 'day', 'hours', 'minutes']}
          inputRef={props.inpRef}
          format="MM/DD/YYYY hh:mm A" 
          value={dayjs(props.dateInput)}
          minDate={dayjs().utc().year(1).month(0).date(1).hour(0).minute(0).second(0).millisecond(0)}
         
          onChange={(newValue) => {
            //setValue(newValue)
            handleOnChange(dayjs(newValue))
          }}
          onError={(reason) => setValidation(reason)} 
         
          />
      
        </LocalizationProvider>

        <div className='minute-button-group'>
        <div className='button-spacer'></div>
        <div className='icon-button-group'>
       
        <StyledStepperButton {...getDecrementButtonProps()} className="decrement-minute"
        onClick={() => {props.setSelectedSection("minutes");}}>
          ◂
        </StyledStepperButton>
        <span className='libre-franklin-chart' style={{paddingLeft:'3px', fontSize:'11px', color:'rgb(2, 51, 101)'}}>MIN</span>
        <StyledStepperButton {...getIncrementButtonProps()} className="increment-minute" 
          onClick={() => {
            props.setSelectedSection("minutes");
        }}
        >
          ▸
        </StyledStepperButton>
       
        
         </div>
         </div>
     </StyledInputRoot>
   
     
    );

    
    
  });
  
const blue = {
    100: '#DAECFF',
    200: '#B6DAFF',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    700: '#0059B2',
    900: '#003A75',
  };
  
  const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  };

  const DateTimeFieldLg= styled(DateTimePicker,{})({

    ".MuiInputBase-input":{
      padding: '7.5px 0px 7.5px 7.5px',
      backgroundColor: 'white',
      textAlign: 'center'
    },
    ".MuiButtonBase-root":{
      padding: '0px'
    },
    ".MuiFormControl-root":{
      padding: '0px 5px 0px 5px'
    }
    // '.MuiInputBase-root{@font-face {font-family: "Libre Franklin";font-style: normal;font-weight: 400;src: url(https://fonts.gstatic.com/s/librefranklin/v18/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsWkANDJTedX18mE.woff2) format("woff2");}}'
   
  });
  
  const StyledInputRoot: React.ElementType = styled('div')(
    ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    border-radius: 8px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fafdff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    //box-shadow: 0px 2px 4px ${
      theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
    //display: grid;
    //grid-template-columns: 1fr 19px;
    //grid-template-rows: 1fr 1fr;
    overflow: hidden;
    column-gap: 8px;
    padding: 8px;
  
  
      &.root:hover {
        border-color: ${blue[400]};
        //box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
  
        // & button:hover {
        //   background: ${blue[400]};
        // }
        // firefox
        &:focus-visible {
          outline: 0;
      }
    `,
  );
  
  const StyledInputElement = styled('input')(
    ({ theme }) => `
    font-size: 0.875rem;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.5;
    grid-column: 1/2;
    grid-row: 1/3;
    grid-column: 1/2;
    grid-row: 1/3;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: inherit;
    border: none;
    border-radius: inherit;
    padding: 8px 12px;
    outline: 0;
  `,
  );

  const HiddenInput = styled('input')`
  visibility: hidden;
  position: absolute;
`;
  
  const StyledStepperButton = styled('button')(
    ({ theme }) => `
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    appearance: none;
    padding-bottom: 8px;
    margin-right:4px;
    margin-left:4px;
    width: 19px;
    height: 7px;
    font-family: system-ui, sans-serif;
    font-size: 1.25rem;
    line-height: 1;
    box-sizing: border-box;
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fafdff'};
    border: 0;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
  
      &.increment-minute,&.increment-hour {
        //grid-column: 1/10;
        //grid-row: 1/1;
        // grid-column: 2/3;
        // grid-row: 1/2;
        //border-top-left-radius: 4px;
        //border-top-right-radius: 4px;
        //border: 1px solid;
        border-radius: 4px;
        border-bottom: 0;
        border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
        //background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
        color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  
        &.increment-minute:hover, &.increment-hour:hover{
          cursor: pointer;
          color: #FFF;
          background: ${theme.palette.mode === 'dark' ? 'rgba(2, 51, 101,1)' : 'rgba(2, 51, 101,.80)'};
          //background: ${theme.palette.mode === 'dark' ? blue[600] : blue[500]};
          border-color: ${theme.palette.mode === 'dark' ? blue[400] : blue[600]};
        }
      }
  
      &.decrement-minute, &.decrement-hour {
        //grid-column: 1/10;
        //grid-row: 3/3;
        // grid-column: 2/3;
        // grid-row: 2/3;
        //border-bottom-left-radius: 4px;
        //border-bottom-right-radius: 4px;
        //border: 1px solid;
        border-radius: 4px;
        border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
        //background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
        //color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
        color: ${theme.palette.mode === 'dark' ? 'rgb(77, 77, 77)' :  'rgb(77, 77, 77)'};
  
  
        &.decrement-minute:hover, &.decrement-hour:hover{
          cursor: pointer;
          color: #FFF;
          background: ${theme.palette.mode === 'dark' ? 'rgba(2, 51, 101,1)' : 'rgba(2, 51, 101,.80)'};
          //background: ${theme.palette.mode === 'dark' ? blue[600] : blue[500]};
          border-color: ${theme.palette.mode === 'dark' ? blue[400] : blue[600]};
        }
    }
    `,
  );

  const Pre = styled('pre')`
  font-size: 0.75rem;
`;
  

export default function WheelInput(props: any ) {
  

  //const [timeCount, setTimeCount] = useState(0);

  // const [dateInput, setDateInput] = useState<Dayjs | null>(props.defaultDate);

  // const materialTheme = useMaterialTheme();

  let planet = null
  let degree = null
  let sign = null
  let minute = null
  let rx = null
  let varTid=''
  let direction=''
  let interval=''

 

  interface ChartInfo  {
    
      utc_date: any;
      signs: any;
      planets: any;
  
}

  async function fetchNewPlanets(direction: string, interval: string, tid: string, lat: string, long: string): Promise<ChartInfo> {
    const response = (process.env.NODE_ENV=='development') ?
    await fetch(`http://localhost:8000/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}`)
    :
    await fetch(`https://api.planetgazer.net/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}`);

    //await fetch(`http://localhost:8000/${direction}/${interval}?tid=${tid}&lat=${lat}&long=${long}`);
    return response.json();
  }
    
  const {data: transits , error, isLoading, isSuccess: SuccessTransit, refetch} = useQuery<ChartInfo>(
    { 
    // placeholderData: "",
    queryKey: ['transits',direction,interval,varTid],
    queryFn: () => fetchNewPlanets(direction,interval,varTid, props.lat.current, props.long.current),
    enabled: false,
    staleTime: Infinity

    });

  
  const handleOnClick  = async  (d: string, i: string) => { 
      if (d == 'forward'){ 
        if (i == 'hour')
          {props.setDefaultDate(dayjs(props.defaultDate).add(1,'hour').local())
          varTid=dayjs(props.defaultDate).add(1,'hour').local().toISOString()}
        else{
          props.setDefaultDate(dayjs(props.defaultDate).add(1,'minute').local())
          varTid=dayjs(props.defaultDate).add(1,'minute').local().toISOString()}
        }
      else{
        if (i == 'hour')
          {props.setDefaultDate(dayjs(props.defaultDate).subtract(1,'hour').local())
          varTid=dayjs(props.defaultDate).subtract(1,'hour').local().toISOString()}
          else{
            props.setDefaultDate(dayjs(props.defaultDate).subtract(1,'minute').local())
            varTid=dayjs(props.defaultDate).subtract(1,'minute').local().toISOString()}
      }
        
      direction = d
      interval = i
      if(varTid && direction && interval &&  props.lat.current && props.long.current) {refetch()}
  };

  useEffect(() => {
    if(SuccessTransit){

         if (transits !== null || transits !== undefined)
             {props.tid.current = transits?.utc_date}
         

        
         console.log("tid:" + props.tid.current)

         console.log(transits)

         props.setSignVals({
             AriSignX: transits?.signs[0].coord[0],
             AriSignY: transits?.signs[0].coord[1],
             TauSignX: transits?.signs[1].coord[0],
             TauSignY: transits?.signs[1].coord[1],
             GemSignX: transits?.signs[2].coord[0],
             GemSignY: transits?.signs[2].coord[1],
             CanSignX: transits?.signs[3].coord[0],
             CanSignY: transits?.signs[3].coord[1],
             LeoSignX: transits?.signs[4].coord[0],
             LeoSignY: transits?.signs[4].coord[1],
             VirSignX: transits?.signs[5].coord[0],
             VirSignY: transits?.signs[5].coord[1],
             LibSignX: transits?.signs[6].coord[0],
             LibSignY: transits?.signs[6].coord[1],
             ScoSignX: transits?.signs[7].coord[0],
             ScoSignY: transits?.signs[7].coord[1],
             SagSignX: transits?.signs[8].coord[0],
             SagSignY: transits?.signs[8].coord[1],
             CapSignX: transits?.signs[9].coord[0],
             CapSignY: transits?.signs[9].coord[1],
             AquSignX: transits?.signs[10].coord[0],
             AquSignY: transits?.signs[10].coord[1],
             PisSignX: transits?.signs[11].coord[0],
             PisSignY: transits?.signs[11].coord[1]
     
         })

         
         transits?.planets.map((p: any) => { 

             if (p.planet == "Mo") {
                 props.setMoVals({  
                     MoSym:"R", 
                     MoPlanetX: p.coord[0][0],
                     MoPlanetY: p.coord[0][1],
                     MoSign: p.sign,
                     MoSignSym: p.signSymbol,
                     MoSignX: p.coord[2][0],
                     MoSignY: p.coord[2][1],
                     MoDegree: p.degree,
                     MoDegreeX: p.coord[1][0],
                     MoDegreeY: p.coord[1][1],
                     MoMinute: p.minute,
                     MoMinuteX: p.coord[3][0],
                     MoMinuteY: p.coord[3][1],
                 })
             }
             if (p.planet == "Me") { 
                 props.setMeVals({
                     MeSym:"S",          
                     MePlanetX: p.coord[0][0],
                     MePlanetY: p.coord[0][1],
                     MeSign: p.sign,
                     MeSignSym: p.signSymbol,
                     MeSignX: p.coord[2][0],
                     MeSignY: p.coord[2][1],
                     MeDegree: p.degree,
                     MeDegreeX: p.coord[1][0],
                     MeDegreeY: p.coord[1][1],
                     MeMinute: p.minute,
                     MeMinuteX: p.coord[3][0],
                     MeMinuteY: p.coord[3][1],
                     MeRX:  p.rx,
                     MeRXX: p.coord[4][0],
                     MeRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Ve") { 
                 props.setVeVals({    
                     VeSym:"T",      
                     VePlanetX: p.coord[0][0],
                     VePlanetY: p.coord[0][1],
                     VeSign: p.sign,
                     VeSignSym: p.signSymbol,
                     VeSignX: p.coord[2][0],
                     VeSignY: p.coord[2][1],
                     VeDegree: p.degree,
                     VeDegreeX: p.coord[1][0],
                     VeDegreeY: p.coord[1][1],
                     VeMinute: p.minute,
                     VeMinuteX: p.coord[3][0],
                     VeMinuteY: p.coord[3][1],
                     VeRX:  p.rx,
                     VeRXX: p.coord[4][0],
                     VeRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Su") { 
                 props.setSuVals({ 
                     SuSym:p.planetSymbol,         
                     SuPlanetX: p.coord[0][0],
                     SuPlanetY: p.coord[0][1],
                     SuSign: p.sign,
                     SuSignSym: p.signSymbol,
                     SuSignX: p.coord[2][0],
                     SuSignY: p.coord[2][1],
                     SuDegree: p.degree,
                     SuDegreeX: p.coord[1][0],
                     SuDegreeY: p.coord[1][1],
                     SuMinute: p.minute,
                     SuMinuteX: p.coord[3][0],
                     SuMinuteY: p.coord[3][1],
                     SuRX: p.coord[4][0],
                     SuRY: p.coord[4][1]
                 })
             }
             
             if (p.planet == "Ma") { 
                 props.setMaVals({
                     MaSym:"U",          
                     MaPlanetX: p.coord[0][0],
                     MaPlanetY: p.coord[0][1],
                     MaSign: p.sign,
                     MaSignSym: p.signSymbol,
                     MaSignX: p.coord[2][0],
                     MaSignY: p.coord[2][1],
                     MaDegree: p.degree,
                     MaDegreeX: p.coord[1][0],
                     MaDegreeY: p.coord[1][1],
                     MaMinute: p.minute,
                     MaMinuteX: p.coord[3][0],
                     MaMinuteY: p.coord[3][1],
                     MaRX: p.rx,
                     MaRXX: p.coord[4][0],
                     MaRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Ju") { 
                 props.setJuVals({ 
                     JuSym:"V",         
                     JuPlanetX: p.coord[0][0],
                     JuPlanetY: p.coord[0][1],
                     JuSign: p.sign,
                     JuSignSym: p.signSymbol,
                     JuSignX: p.coord[2][0],
                     JuSignY: p.coord[2][1],
                     JuDegree: p.degree,
                     JuDegreeX: p.coord[1][0],
                     JuDegreeY: p.coord[1][1],
                     JuMinute: p.minute,
                     JuMinuteX: p.coord[3][0],
                     JuMinuteY: p.coord[3][1],
                     JuRX: p.rx,
                     JuRXX: p.coord[4][0],
                     JuRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Sa") { 
                 props.setSaVals({
                     SaSym:"W",          
                     SaPlanetX: p.coord[0][0],
                     SaPlanetY: p.coord[0][1],
                     SaSign: p.sign,
                     SaSignSym: p.signSymbol,
                     SaSignX: p.coord[2][0],
                     SaSignY: p.coord[2][1],
                     SaDegree: p.degree,
                     SaDegreeX: p.coord[1][0],
                     SaDegreeY: p.coord[1][1],
                     SaMinute: p.minute,
                     SaMinuteX: p.coord[3][0],
                     SaMinuteY: p.coord[3][1],
                     SaRX: p.rx,
                     SaRXX: p.coord[4][0],
                     SaRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Ur") { 
                 props.setUrVals({  
                     UrSym:"X",        
                     UrPlanetX: p.coord[0][0],
                     UrPlanetY: p.coord[0][1],
                     UrSign: p.sign,
                     UrSignSym: p.signSymbol,
                     UrSignX: p.coord[2][0],
                     UrSignY: p.coord[2][1],
                     UrDegree: p.degree,
                     UrDegreeX: p.coord[1][0],
                     UrDegreeY: p.coord[1][1],
                     UrMinute: p.minute,
                     UrMinuteX: p.coord[3][0],
                     UrMinuteY: p.coord[3][1],
                     UrRX: p.rx,
                     UrRXX: p.coord[4][0],
                     UrRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Ne") { 
                 props.setNeVals({  
                     NeSym:"Y",        
                     NePlanetX: p.coord[0][0],
                     NePlanetY: p.coord[0][1],
                     NeSign: p.sign,
                     NeSignSym: p.signSymbol,
                     NeSignX: p.coord[2][0],
                     NeSignY: p.coord[2][1],
                     NeDegree: p.degree,
                     NeDegreeX: p.coord[1][0],
                     NeDegreeY: p.coord[1][1],
                     NeMinute: p.minute,
                     NeMinuteX: p.coord[3][0],
                     NeMinuteY: p.coord[3][1],
                     NeRX: p.rx,
                     NeRXX: p.coord[4][0],
                     NeRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Pl") { 
                 props.setPlVals({   
                     PlSym:"Z",       
                     PlPlanetX: p.coord[0][0],
                     PlPlanetY: p.coord[0][1],
                     PlSign: p.sign,
                     PlSignSym: p.signSymbol,
                     PlSignX: p.coord[2][0],
                     PlSignY: p.coord[2][1],
                     PlDegree: p.degree,
                     PlDegreeX: p.coord[1][0],
                     PlDegreeY: p.coord[1][1],
                     PlMinute: p.minute,
                     PlMinuteX: p.coord[3][0],
                     PlMinuteY: p.coord[3][1],
                     PlRX: p.rx,
                     PlRXX: p.coord[4][0],
                     PlRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Ra") { 
                 props.setRaVals({
                     RaSym:"<",          
                     RaPlanetX: p.coord[0][0],
                     RaPlanetY: p.coord[0][1],
                     RaSign: p.sign,
                     RaSignSym: p.signSymbol,
                     RaSignX: p.coord[2][0],
                     RaSignY: p.coord[2][1],
                     RaDegree: p.degree,
                     RaDegreeX: p.coord[1][0],
                     RaDegreeY: p.coord[1][1],
                     RaMinute: p.minute,
                     RaMinuteX: p.coord[3][0],
                     RaMinuteY: p.coord[3][1],
                     RaRX: p.rx,
                     RaRXX: p.coord[4][0],
                     RaRXY: p.coord[4][1],
                     RXSym: 'M' 
                 })
             }
             if (p.planet == "Ke") { 
                 props.setKeVals({ 
                     KeSym:">",         
                     KePlanetX: p.coord[0][0],
                     KePlanetY: p.coord[0][1],
                     KeSign: p.sign,
                     KeSignSym: p.signSymbol,
                     KeSignX: p.coord[2][0],
                     KeSignY: p.coord[2][1],
                     KeDegree: p.degree,
                     KeDegreeX: p.coord[1][0],
                     KeDegreeY: p.coord[1][1],
                     KeMinute: p.minute,
                     KeMinuteX: p.coord[3][0],
                     KeMinuteY: p.coord[3][1],
                     KeRX: p.rx,
                     KeRXX: p.coord[4][0],
                     KeRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "Ch") { 
                 props.setChVals({  
                     ChSym:"t",        
                     ChPlanetX: p.coord[0][0],
                     ChPlanetY: p.coord[0][1],
                     ChSign: p.sign,
                     ChSignSym: p.signSymbol,
                     ChSignX: p.coord[2][0],
                     ChSignY: p.coord[2][1],
                     ChDegree: p.degree,
                     ChDegreeX: p.coord[1][0],
                     ChDegreeY: p.coord[1][1],
                     ChMinute: p.minute,
                     ChMinuteX: p.coord[3][0],
                     ChMinuteY: p.coord[3][1],
                     ChRX: p.rx,
                     ChRXX: p.coord[4][0],
                     ChRXY: p.coord[4][1]
                 })
             }
             if (p.planet == "ASC") { 
                 props.setASCVals({
                     ASCSym:"a",          
                     ASCPlanetX: p.coord[0][0],
                     ASCPlanetY: p.coord[0][1],
                     ASCSign: p.sign,
                     ASCSignSym: p.signSymbol,
                     ASCSignX: p.coord[2][0],
                     ASCSignY: p.coord[2][1],
                     ASCDegree: p.degree,
                     ASCDegreeX: p.coord[1][0],
                     ASCDegreeY: p.coord[1][1],
                     ASCMinute: p.minute,
                     ASCMinuteX: p.coord[3][0],
                     ASCMinuteY: p.coord[3][1]
                 })
     
             }
             if (p.planet == "DSC") { 
                 props.setDSCVals({
                     DSCSym:"DC",          
                     DSCPlanetX: p.coord[0][0],
                     DSCPlanetY: p.coord[0][1],
                     DSCSign: p.sign,
                     DSCSignSym: p.signSymbol,
                     DSCSignX: p.coord[2][0],
                     DSCSignY: p.coord[2][1],
                     DSCDegree: p.degree,
                     DSCDegreeX: p.coord[1][0],
                     DSCDegreeY: p.coord[1][1],
                     DSCMinute: p.minute,
                     DSCMinuteX: p.coord[3][0],
                     DSCMinuteY: p.coord[3][1]
                 })
             }
             if (p.planet == "IC") { 
                 props.setICVals({ 
                     ICSym:"c",         
                     ICPlanetX: p.coord[0][0],
                     ICPlanetY: p.coord[0][1],
                     ICSign: p.sign,
                     ICSignSym: p.signSymbol,
                     ICSignX: p.coord[2][0],
                     ICSignY: p.coord[2][1],
                     ICDegree: p.degree,
                     ICDegreeX: p.coord[1][0],
                     ICDegreeY: p.coord[1][1],
                     ICMinute: p.minute,
                     ICMinuteX: p.coord[3][0],
                     ICMinuteY: p.coord[3][1]
                 })
             }
             if (p.planet == "MC") { 
                 props.setMCVals({ 
                     MCSym:"b",         
                     MCPlanetX: p.coord[0][0],
                     MCPlanetY: p.coord[0][1],
                     MCSign: p.sign,
                     MCSignSym: p.signSymbol,
                     MCSignX: p.coord[2][0],
                     MCSignY: p.coord[2][1],
                     MCDegree: p.degree,
                     MCDegreeX: p.coord[1][0],
                     MCDegreeY: p.coord[1][1],
                     MCMinute: p.minute,
                     MCMinuteX: p.coord[3][0],
                     MCMinuteY: p.coord[3][1]
                 })
             }
             if (p.planet == "LoFo") { 
              props.setLoFoVals({ 
                  LoFoSym:";",         
                  LoFoPlanetX: p.coord[0][0],
                  LoFoPlanetY: p.coord[0][1],
                  LoFoSign: p.sign,
                  LoFoSignSym: p.signSymbol,
                  LoFoSignX: p.coord[2][0],
                  LoFoSignY: p.coord[2][1],
                  LoFoDegree: p.degree,
                  LoFoDegreeX: p.coord[1][0],
                  LoFoDegreeY: p.coord[1][1],
                  LoFoMinute: p.minute,
                  LoFoCMinuteX: p.coord[3][0],
                  LoFoMinuteY: p.coord[3][1]
              })
          }
             
             })
         }
     }
     ,[transits])

    return(
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <CustomNumberInput 
        dateInput={props.defaultDate} setDateInput={props.setDefaultDate} 
        setSelectedSection={props.setSelectedSectionType} selectedSection={props.selectedSections} 
        inpRef={props.inputRef} tid={props.tid} setAllowedToFetch={props.setAllowedToFetch} refetch={props.refetch}
        lat={props.lat} long={props.long} getDateInput={props.getDateInput}
        props={props}
        aria-label="increment decrement hours minutes" 
        //value={timeCount}
        onClick={(event: any, val: number) => {
          const btnClass = event.target.classList[0]
          if(btnClass !== undefined && event.target.localName=='button'){
          const btn = btnClass.split('-')[1]
          console.log(btn)
          if ( btn != "root"){
            props.setAllowedToFetch(false) 
            //const btnClass = event.target.classList[0] 
            direction=btnClass.split('-')[0] == 'increment' ? 'forward' : 'back'
            interval=btnClass.split('-')[1]
            handleOnClick(direction,interval);

          } }
          }}
            
           />
    </LocalizationProvider>
    )
  }

  // return (
  //   <MaterialCssVarsProvider>
  //     <CssVarsProvider theme={{ [THEME_ID]: joyTheme }}>
  //       <SyncThemeMode mode={materialTheme.palette.mode} />
        
  //       <ThemeProvider theme={MuiOutlinedInput}>
  //         <LocalizationProvider dateAdapter={AdapterDayjs}>
  //         <DatePicker sx={{ minWidth: '100px',paddingTop: 3}}
  //         slotProps={{ textField: { size: 'small' } }} 
  //         format="MM/DD/YYYY hh:mm A"
  //         value={dayjs(props.defaultDate)}
  //         // onChange={(newValue:any) => props.setDefaultDate(newValue)}
  //          /> 
  //          <JoyDatePicker
  //           slotProps={{
  //             field: { clearable: true, 
  //                   value: dayjs(props.defaultDate).local(),
  //                   // onChange: (newValue) => props.setDefaultDate(newValue)
  //               },
  //           }}
  //         /> 
            //   <CustomNumberInput dateInput={props.defaultDate} setDateInput={props.setDefaultDate} props={props}
            //   aria-label="Demo number input" 
            //   placeholder="Type a number…"
            //   value={timeCount}
            //   onChange={(event: any, val: number) => {
            //   console.log(`Event type: ${event.type}`);
            //   setTimeCount(val);
            //   props.setDefaultDate(dateInput)

            // }}
              
            //   />


          
  //       </LocalizationProvider>
  //      </ThemeProvider>
  //     // </CssVarsProvider>
  //   // </MaterialCssVarsProvider>
  // );

  


// export default function UseNumberInput() {
//   return (
//     <CustomNumberInput aria-label="Demo number input" placeholder="Type a number…" />
//   );
// }

// const IncrementButton = React.forwardRef(
//   function IncrementButton(
//     props: UseNumberInputParameters & React.InputHTMLAttributes<HTMLInputElement>,
//     ref: React.ForwardedRef<HTMLInputElement>,
//   ) {
//     const {
//       getIncrementButtonProps,
//     } = useNumberInput(props);

  
//     return (
    
//         <StyledStepperButton {...getIncrementButtonProps()} className="increment">
//           ▴
//         </StyledStepperButton>
//     );
//   });
  
//   const DecrementButton = React.forwardRef(

//     function DecrementButton(
//       props: UseNumberInputParameters & React.InputHTMLAttributes<HTMLInputElement>,
//       ref: React.ForwardedRef<HTMLInputElement>,
//     ) {
//       const {
//         getDecrementButtonProps,
//         focused,
//       } = useNumberInput(props);

    
//       return (
//           <StyledStepperButton {...getDecrementButtonProps()} className="decrement">
//             ▾
//           </StyledStepperButton>
//       );
//     });

//     const StyledInput = React.forwardRef(

//       function StyledInput(
//         props: UseNumberInputParameters & React.InputHTMLAttributes<HTMLInputElement>,
//         ref: React.ForwardedRef<HTMLInputElement>,
//       ) {
//         const {

//           getInputProps
//         } = useNumberInput(props);
      
//         const inputProps = getInputProps();
    
//         // Make sure that both the forwarded ref and the ref returned from the getInputProps are applied on the input element
//         inputProps.ref = useForkRef(inputProps.ref, ref);
      
//         return (
          
//             <StyledInputElement {...inputProps} />
//         );
//       });

//       const StyledRoot = React.forwardRef(

//         function StyledRoot(
//           props: UseNumberInputParameters & React.InputHTMLAttributes<HTMLInputElement>,
//           ref: React.ForwardedRef<HTMLInputElement>,
//         ) {
//           const {
//             getRootProps,
//             focused,
//           } = useNumberInput(props);
        
//           return (
//             <StyledInputRoot {...getRootProps()} className={focused ? 'focused' : null}>
        
//            </StyledInputRoot>
//           );
//         });
